import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Label, Pagination, Select, Table } from 'semantic-ui-react';
import { API, showError, timestamp2string } from '../helpers';
import { ITEMS_PER_PAGE } from '../constants';

const CHANNEL_OPTIONS = [
  { key: 'all', text: '全部渠道', value: '' },
  { key: 'oa', text: '公众号模板消息', value: 'oa' },
  { key: 'email', text: '邮件', value: 'email' },
  { key: 'sms', text: '短信', value: 'sms' },
  { key: 'oa_bind_callback', text: '公众号关联回调', value: 'oa_bind_callback' },
];

const STATUS_OPTIONS = [
  { key: 'all', text: '全部状态', value: '' },
  { key: '1', text: '成功', value: '1' },
  { key: '2', text: '失败', value: '2' },
];

const MessageLogTable = () => {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState(1);
  const [clients, setClients] = useState([]);
  const [clientId, setClientId] = useState('');
  const [channel, setChannel] = useState('');
  const [status, setStatus] = useState('');
  const [templateKey, setTemplateKey] = useState('');

  const loadClients = async () => {
    const res = await API.get('/api/message/clients/');
    const { success, data } = res.data;
    if (success) {
      setClients([
        { key: 'all', text: '全部系统', value: '' },
        ...(data || []).map((id) => ({ key: id, text: id, value: id })),
      ]);
    }
  };

  const loadLogs = async (
    page = 1,
    client = clientId,
    ch = channel,
    st = status,
    tk = templateKey
  ) => {
    setLoading(true);
    let url = `/api/message/log/?p=${page - 1}`;
    if (client) url += `&client_id=${encodeURIComponent(client)}`;
    if (ch) url += `&channel=${ch}`;
    if (st !== '') url += `&status=${st}`;
    if (tk) url += `&template_key=${encodeURIComponent(tk)}`;
    const res = await API.get(url);
    const { success, message, data, total: count } = res.data;
    if (success) {
      setLogs(data || []);
      setTotal(count || 0);
      setActivePage(page);
    } else {
      showError(message);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadClients().catch((reason) => showError(reason));
    loadLogs(1).catch((reason) => showError(reason));
  }, []);

  return (
    <>
      <Form>
        <Form.Group>
          <Form.Field width={3}>
            <Select
              options={clients.length > 0 ? clients : [{ key: 'all', text: '全部系统', value: '' }]}
              value={clientId}
              onChange={(e, { value }) => {
                setClientId(value);
                loadLogs(1, value, channel, status, templateKey).catch((reason) =>
                  showError(reason)
                );
              }}
            />
          </Form.Field>
          <Form.Field width={3}>
            <Select
              options={CHANNEL_OPTIONS}
              value={channel}
              onChange={(e, { value }) => {
                setChannel(value);
                loadLogs(1, clientId, value, status, templateKey).catch((reason) =>
                  showError(reason)
                );
              }}
            />
          </Form.Field>
          <Form.Field width={3}>
            <Select
              options={STATUS_OPTIONS}
              value={status}
              onChange={(e, { value }) => {
                setStatus(value);
                loadLogs(1, clientId, channel, value, templateKey).catch((reason) =>
                  showError(reason)
                );
              }}
            />
          </Form.Field>
          <Form.Field width={4}>
            <Input
              placeholder='按 template_key 过滤'
              value={templateKey}
              onChange={(e) => setTemplateKey(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  loadLogs(1).catch((reason) => showError(reason));
                }
              }}
            />
          </Form.Field>
          <Button
            type='button'
            loading={loading}
            onClick={() =>
              loadLogs(1).catch((reason) => showError(reason))
            }
          >
            刷新
          </Button>
        </Form.Group>
      </Form>
      <Table basic={'very'} compact size='small'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>ID</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>系统</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>渠道</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>业务标识</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>平台模板 ID</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>接收方（脱敏）</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>状态</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>回执 ID</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>错误</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>额度</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>耗时</Table.HeaderCell>
            <Table.HeaderCell style={{ whiteSpace: 'nowrap' }}>时间</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {logs.map((log) => (
            <Table.Row key={log.id}>
              <Table.Cell>{log.id}</Table.Cell>
              <Table.Cell>
                <code style={{ fontSize: '12px' }}>{log.client_id || '-'}</code>
                <div style={{ color: '#8a919f', fontSize: '12px' }}>token #{log.token_id}</div>
              </Table.Cell>
              <Table.Cell>{log.channel_text || log.channel}</Table.Cell>
              <Table.Cell>
                <code style={{ fontSize: '12px' }}>{log.template_key || '-'}</code>
              </Table.Cell>
              <Table.Cell>
                <code style={{ fontSize: '12px' }}>{log.platform_template_id || '-'}</code>
              </Table.Cell>
              <Table.Cell>
                <code style={{ fontSize: '12px' }}>{log.target || '-'}</code>
              </Table.Cell>
              <Table.Cell>
                <Label basic color={log.status === 1 ? 'green' : 'red'}>
                  {log.status === 1 ? '成功' : '失败'}
                </Label>
              </Table.Cell>
              <Table.Cell>
                <code style={{ fontSize: '12px' }}>{log.msgid || '-'}</code>
              </Table.Cell>
              <Table.Cell style={{ maxWidth: 240 }}>
                <div style={{ fontSize: '12px', wordBreak: 'break-all', color: '#c0392b' }}>
                  {log.errcode ? `${log.errcode} ${log.errmsg || ''}` : '-'}
                </div>
              </Table.Cell>
              <Table.Cell>{log.quota || 0}</Table.Cell>
              <Table.Cell>{log.elapsed_ms ? `${log.elapsed_ms} ms` : '-'}</Table.Cell>
              <Table.Cell style={{ whiteSpace: 'nowrap' }}>
                {log.created_at > 0 ? timestamp2string(log.created_at) : '-'}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan='12'>
              <Pagination
                floated='right'
                activePage={activePage}
                onPageChange={(e, { activePage: page }) =>
                  loadLogs(page).catch((reason) => showError(reason))
                }
                size='small'
                siblingRange={1}
                totalPages={Math.max(1, Math.ceil(total / ITEMS_PER_PAGE))}
              />
              <span style={{ color: '#8a919f' }}>共 {total} 条消息记录（正文与手机号/邮箱已脱敏）</span>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </>
  );
};

export default MessageLogTable;
